<template>
  <div style="text-align: left">
    <div class="mt-3">
      <div class="container">
        <div class="header_background">
          <table>
            <tr style="width:100%;">
              <td style="width:50%;">
                <div class="sectionHead">
                  <b>Explore Categories </b>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <h5
            style="color: #b4b4b4;margin-left: 23%;margin-top: 25%;"
            v-if="!ListAllCategories || !ListAllCategories.length">
             No Categories Available.
          </h5>
        </div>
        <div>
          <div class="row" style="margin-top:5%;margin-bottom:5%;">
            <div
              class="col-6"
              style="text-align: center; border: 0px solid;"
              v-for="List in ListAllCategories"
              :key="List.id"
            >
              <a :href="'/m/category?cattype=' + List.slug">
                <div
                  style="background-color: #ffffff; border-radius: 16px;height: 82%;"
                >
                  <img
                    :src="List.category_image.url"
                    style="width: 100%; border-radius: 16px;height: 120%;margin-bottom:5%;"
                  />
                </div>
                <div style="font-size: 10pt;"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";

import Strapi from "../services/strapi-services.js";
const strapi = new Strapi();

toVue3.register(Vue2, Vue3);

export default {
  name: "MobViewAllCategories",
  components: {
  },
  data() {
    return {
      finalId: 0,
      cattype: "deals",
      ListAllCategories: [],
    };
  },
  created() {
    // document.title = "Deals @ Koko";
    document.title = "Buy Now Pay Later with Koko";
    this.AllCategories();
  },
  methods: {
    AllCategories() {
      strapi
        .getAllCategories()
        .then((res) => {
          this.ListAllCategories = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 0px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

  text-align: left;
}

.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  /* line-height: 42px; */
  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

.header_background {
  height: 53px;
  margin-bottom: 5%;
  margin-top: 5%;
}

@import url(https://fonts.googleapis.com/css?family=Pacifico);

#base {
  -webkit-transform-style: preserve-3d;
  position: absolute;
  top: 23%;
  left: 50%;
  background-color: black;
  -webkit-transform: translate(-50%, -50%) rotateX(90deg);
  -webkit-animation: anim 3s infinite linear;
}
@-webkit-keyframes anim {
  0% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(0deg);
  }
  15% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(0deg);
  }
  25% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(90deg);
  }
  40% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(90deg);
  }
  50% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(180deg);
  }
  65% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(180deg);
  }
  75% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(270deg);
  }
  90% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(270deg);
  }
  100% {
    -webkit-transform: translate(-50%, -50%) rotateX(90deg) rotateZ(360deg);
  }
}

#loving {
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, 100%);
  text-align: center;
  font: 2em "Pacifico";
  color: black;
}

.f11 {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 70px;
  width: 32px;
  overflow: hidden;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 0 50%;
  -webkit-transform: translate(0%, -50%) rotateX(-90deg);
}

.f11:after {
  content: "";
  position: absolute;
  left: -15px;
  border-top-left-radius: 30px;
  border-top-right-radius: 50px;
  width: 40px;
  height: 60px;
  -webkit-transform: rotate(45deg);

  -webkit-animation: c1 3s infinite linear;
}

@-webkit-keyframes c1 {
  0% {
    background-color: #de1a00;
  }
  15% {
    background-color: #de1a00;
  }
  25% {
    background-color: #de1a00;
  }
  30% {
    background-color: #fa7c07;
  }
  40% {
    background-color: #fa7c07;
  }
  50% {
    background-color: #fa7c07;
  }
  65% {
    background-color: #fa7c07;
  }
  75% {
    background-color: #fa7c07;
  }
  90% {
    background-color: #de1a00;
  }
  100% {
    background-color: #de1a00;
  }
}

@-webkit-keyframes c2 {
  0% {
    background-color: #ff3c00;
  }
  15% {
    background-color: #ff3c00;
  }
  25% {
    background-color: #ff3c00;
  }
  30% {
    background-color: #ff3c00;
  }
  40% {
    background-color: #ff3c00;
  }
  50% {
    background-color: #ff4800;
  }
  65% {
    background-color: #ff4800;
  }
  75% {
    background-color: #ff4800;
  }
  90% {
    background-color: #ff4800;
  }
  100% {
    background-color: #de1a00;
  }
}

.f12 {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 70px;
  width: 32px;
  overflow: hidden;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 0 50%;
  -webkit-transform: translate(0%, -50%) rotateX(-90deg) rotateY(90deg);
}

.f12:after {
  content: "";
  position: absolute;
  left: -15px;
  border-top-left-radius: 30px;
  border-top-right-radius: 50px;
  width: 40px;
  height: 60px;
  -webkit-transform: rotate(45deg);

  -webkit-animation: c2 3s infinite linear;
}

.f13 {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 70px;
  width: 32px;
  overflow: hidden;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 0 50%;
  -webkit-transform: translate(0%, -50%) rotateX(-90deg) rotateY(180deg);
}

.f13:after {
  content: "";
  position: absolute;
  left: -15px;
  border-top-left-radius: 30px;
  border-top-right-radius: 50px;
  width: 40px;
  height: 60px;
  -webkit-transform: rotate(45deg);

  -webkit-animation: c1 3s infinite linear;
}

.f14 {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 70px;
  width: 32px;
  overflow: hidden;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 0 50%;
  -webkit-transform: translate(0%, -50%) rotateX(-90deg) rotateY(270deg);
}

.f14:after {
  content: "";
  position: absolute;
  left: -15px;
  border-top-left-radius: 30px;
  border-top-right-radius: 50px;
  width: 40px;
  height: 60px;
  -webkit-transform: rotate(45deg);

  -webkit-animation: c2 3s infinite linear;
}

@keyframes beat {
  0% {
    transform: scale(1) rotate(225deg);
    box-shadow: 0 0 40px #d5093c;
  }
  50% {
    transform: scale(1.1) rotate(225deg);
    box-shadow: 0 0 70px #d5093c;
  }
  100% {
    transform: scale(1) rotate(225deg);
    box-shadow: 0 0 40px #d5093c;
  }
}

/* Hearts Falling  */

/* apply a natural box layout model to all elements,
but allowing components to change */

blockquote {
  border: 2px solid pink;
  padding: 10px;
}

.heart-pulse {
  animation: pulse 2s infinite;
  display: inline-block;
}
@keyframes pulse {
  0% {
    /* starts small */
    transform: scale(0.5);
  }
  50% {
    /* halfway point - gets bigger */
    transform: scale(1);
  }
  100% {
    /* end - goes back to starting size */
    transform: scale(0.5);
  }
}

body {
  margin: 0;
  padding: 0;
  background-color: #d2bfdb;
}

svg {
  overflow: visible;
}
svg path#line {
  fill: none;
  stroke: #e00000;
  stroke-width: 2;
  stroke-linecap: butt;
  stroke-linejoin: round;
  stroke-miterlimit: 4;
  stroke-dasharray: none;
  stroke-opacity: 1;
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  animation: dash 4s linear infinite;
}
svg path#heart {
  transform-origin: 50% 50%;
  animation: blink 4s linear infinite;
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1;
  }
  80% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes blink {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  60% {
    opacity: 0;
    transform: scale(0);
  }
  70% {
    opacity: 1;
    transform: scale(1.2);
  }
  75% {
    opacity: 1;
    transform: scale(1);
  }
  80% {
    opacity: 1;
    transform: scale(1.2);
  }
  85% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@import url("https://fonts.googleapis.com/css2?family=Pacifico&display=swap");

.valentines-day-card {
  position: relative;
  width: 100%;
  height: 400px;
  /*   background-image: #ff8fa3; */
  background-image: url("https://img.alicdn.com/imgextra/i4/O1CN01XChs5Z1a1FTadlEfq_!!6000000003269-0-tps-600-300.jpg");
  overflow: hidden;
  border: 10px solid white;
  border-radius: 10px;
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
  background-size: cover;
  position: relative;
}

.valentines-day-card:before {
  content: "";
  position: absolute;
  background-color: #ffb3c1;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  top: 320px;
  left: -25px;
  box-shadow: 60px 20px #ffb3c1, 130px 10px #ffb3c1, 190px 20px #ffb3c1,
    260px -5px #ffb3c1, 340px 20px #ffb3c1;
}

.valentines-day-card:after {
  content: "";
  position: absolute;
  background-color: #ffccd5;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  top: 310px;
  left: -40px;
  box-shadow: 50px 20px #ffccd5, 120px 40px #ffccd5, 200px 15px #ffccd5,
    260px 30px #ffccd5, 330px 30px #ffccd5, 380px 10px #ffccd5;
}

.clouds {
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #fff0f3;
  z-index: 5;
  top: 270px;
  left: -20px;
  box-shadow: 55px 30px #fff0f3, 125px 10px #fff0f3, 175px 20px #fff0f3,
    250px 10px #fff0f3, 320px 5px #fff0f3, 380px 10px #fff0f3;
}

.hearts {
  position: absolute;
  z-index: 2;
}

.heartOne {
  position: absolute;
  left: 100px;
  top: 250px;
  animation: up 4s linear forwards 1s;
}

.heartTwo {
  position: absolute;
  left: 270px;
  top: 230px;
  animation: up 5s linear forwards 1.8s;
}

.heartThree {
  position: absolute;
  left: 85px;
  top: 415px;
  animation: up 5s linear forwards 3s;
}

.heartFour {
  position: absolute;
  left: 320px;
  top: 380px;
  animation: upTwo 9s linear infinite 3.5s;
}

.heartFive {
  position: absolute;
  left: 150px;
  top: 400px;
  animation: upTwo 13s linear infinite 4.5s;
}

.right-side:before,
.right-side:after {
  position: absolute;
  content: "";
  transform-origin: left;
  animation: move 1s ease infinite;
}

.right-side:before {
  border-radius: 50% 50% 50% 0;
  width: 21px;
  height: 20px;
  background-color: #c9184a;
  left: -0.26px;
}

.right-side:after {
  height: 0;
  width: 0;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #c9184a;
  top: 19px;
  left: -0.26px;
}

@keyframes move {
  0%,
  100% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(-45deg);
  }
}

.left-side:before,
.left-side:after {
  position: absolute;
  content: "";
  transform-origin: right;
  animation: move 1s ease infinite;
}

.left-side:before {
  border-radius: 50% 50% 0 50%;
  width: 20px;
  height: 20px;
  left: -20.7px;
  background-color: #ff4d6d;
}

.left-side:after {
  height: 0;
  width: 0;
  left: -15px;
  border-bottom: 10px solid transparent;
  border-right: 15px solid #ff4d6d;
  top: 19px;
}

@keyframes up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-200px);
  }
}

@keyframes upTwo {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-450px);
  }
}

.text {
  color: #c9a018;
  font-size: 25px;
  font-family: "Pacifico", cursive;
  text-align: left;
  margin-top: 4%;
  margin-bottom: 4%;
}

.NoDeals {
  color: #222222;
  font-size: 25px;
  font-family: "Pacifico", cursive;
  text-align: center;
  margin-top: 50%;
  margin-bottom: 4%;
}

.hover {
  color: white;
  font-family: "Pacifico", cursive;
  text-align: center;
}

.text:hover span {
  display: none;
}
</style>
